import React from "react"
import * as Chakra from "@chakra-ui/react"
import { ScrollFadeIn } from "../animation-helpers/animation-state"
import {ResponsiveVideoImage} from "../video-image";

interface ProjectLargeImageProps {
  image: any
  video_url?: string
  customMaxWidth?: number
  removeMaxHeight?: "yes" | "no"
}

const ProjectLargeImage = React.forwardRef(
  (props: ProjectLargeImageProps, ref) => {
    return (
      <Chakra.Box
        ref={ref}
        width="100%"
        display="flex"
        position="relative"
        alignItems="center"
        flexDirection="column"
        backgroundColor="transparent"
      >
        <Chakra.Box
          width="100%"
          display="flex"
          maxWidth="1800px"
          alignItems="center"
          marginLeft="auto"
          marginRight="auto"
          paddingLeft="40px"
          paddingRight="40px"
          justifyContent="center"
          css={{
            "@media (max-width: 767px)": {
              paddingLeft: "20px",
              paddingRight: "20px",
            },
          }}
          className="project-block"
          as={ScrollFadeIn}
        >
          <ResponsiveVideoImage
            image={props.image}
            video_url={props.video_url}
            width="100%"
            maxWidth={props?.customMaxWidth ? `${props.customMaxWidth}%` : "100%"}
            maxHeight={props.removeMaxHeight === "yes" ? "unset" : "752px"}
            objectFit="cover"
            objectPosition="center center"
          />
        </Chakra.Box>
      </Chakra.Box>
    )
  }
)

ProjectLargeImage.pressless = {
  name: "Project Large Image",
  attributes: {
    image: {
      name: "Image",
      type: "Image",
    },
    video_url: {
      name: "Video (URL)",
      type: "PlainText",
    },
    customMaxWidth: {
      name: "Custom Max Width",
      type: "Number",
      description: "Add a custom max width to the image. (Percentage based out of max-size of 1800px)."
    },
    removeMaxHeight: {
      name: "Remove Max Height",
      type: "Select",
      options: [{ no: "No" }, { yes: "Yes" }],
      description: "Remove the preset Maximum Height defined in the design. This will allow for correct aspect ratio of images."
    },
  },
}
export default ProjectLargeImage
